import axios from 'axios';
import {rootUrl} from './rootUrl.js';
export let user={
  info(params) {
    return axios.get(rootUrl + '/user/info', params)
  },
  checkPwd(params) {
    return axios.post(rootUrl + '/wechat/checkPwd', params)
  },
  //这个接口竟然是验证手机号和验证码是否匹配的接口,防止混淆,特意放在这里;
  updatePhone(params) {
    return axios.post(rootUrl + '/user/updatePhone', params)
  },
  //这个接口竟然是绑定手机号的接口,能够校验手机号是否已经使用了;
  checkPhone(params) {
    return axios.post(rootUrl + '/user/checkPhone', params)
  },
  //校验验证码,并更新邮箱;
  checkEmail(params) {
    return axios.post(rootUrl + '/wechat/checkEmail', params)
  },
  //校验验证码,
  checkEmailCode(params) {
    return axios.post(rootUrl + '/user/checkEmailCode', params)
  },
  // 账号信息---修改信息
  updateUserInfo(params) {
    return axios.post(rootUrl + '/user/updateUserInfo', params)
  },
  updatePwd(params) {
    return axios.post(rootUrl + '/user/updatePwd', params)
  },
  //校验邮箱是否存在
  checkEmailExist(params) {
    return axios.post(rootUrl + '/user/checkEmailExist', params)
  },
  //修改账号信息新
  updateUser(params) {
    return axios.post(rootUrl + '/wechat/updateUser', params)
  },
  //账号信息国家
  selectCountryList(params) {
    return axios.post(rootUrl + '/country/selectCountryList', params)
  },
  //绑定邮箱发验证码
   sendValidCodeToMail(params) {
    return axios.post(rootUrl + '/wechat/sendValidCodeToMail', params)
  },
  //确认绑定邮箱
   checkEmailBindingForWechat(params) {
    return axios.post(rootUrl + '/user/checkEmailBindingForWechat', params)
  },
  //绑定微信
   bindingWechat(params) {
    return axios.post(rootUrl + '/wechat/bindingWechat', params)
  },
   //绑定微信
   removeBinding(params) {
    return axios.post(rootUrl + '/wechat/removeBinding', params)
  },
  //上传图片
   uploadPortrait(params) {
    return axios.post(rootUrl + '/wechat/uploadPortrait', params)
  },
   //验证手机-发送验证码
   memberValidataCodeWithPhone(params) {
    return axios.post(rootUrl + '/member/memberValidataCodeWithPhone', params)
  },
   //验证手机-保存手机号
   wechatSavePhone(params) {
    return axios.post(rootUrl + '/member/wechatSavePhone', params)
  },
};



// WEBPACK FOOTER //
// ./src/service/user.js